export default {
  primary: { blue: '#0e497b' },
  accent: { blue: '#092d4d' }, // example: This is the font color for the values section // TODO: confirm these values after getting Sketch file
  hero: {
    background: '#667785', // TODO: rename/organize these once comp is finalized.
    textStroke: '#2e353a', // TODO: rename/organize these once comp is finalized.
  },
  section: { backgroundBlue: '#0e497b' },
  neutral: {
    white: '#fff',
    grey99: '#f8fafc',
    grey95: '#edf0f3',
    grey59: '#979797',
    grey54: '#8a8a8a',
    grey29: '#4a4a4a',
    grey23: '#3a3a3a',
    black: '#000',
  },
  cta: {
    blue: '#1570bc',
    hoverBlue: '#0e497b',
    activeBlue: '#105fcc',
    yellow: '#ffb81c',
    hoverYellow: '#cc8b00',
    activeYello: '#FFB81C',
  },
  system: {
    cautionWarning: '#ffcc33',
    darkBlue: '#004ab3',
    negativeError: '#ff5242',
    darkRed: '#dc100d',
    positiveSuccess: '#00a84f',
    darkGreen: '#00803c',
  },
  pcg: {
    gold1: '#e1c88f',
    gold2: '#f2dfac',
    darkBlue1: '#0F1117',
    darkBlue2: '#0F2160',
  },

  // Other
  blueOnBlueHeadingAccess: '#83d4f1', // TODO: rename/organize these once comp is finalized.
  blueLazyloadBg: '#afb9c0', // #667785; // #8597a1;

  // TODO: build in shade and highlight functions
};
